import { gql } from '@apollo/client';

export type Income = {
  id: number;
  salaryIncome: string;
  salaryEarnings: string;
  businessIncome: string;
  businessExpense: string;
  businessEarnings: string;
  miscellaneousIncomeOfficalPension: string;
  miscellaneousIncomeOther: string;
  miscellaneousExpense: string;
  miscellaneousEarnings: string;
  dividendIncome: string;
  dividendExpense: string;
  dividendEarnings: string;
  realEstateIncome: string;
  realEstateExpense: string;
  realEstateEarnings: string;
  retirementIncome: string;
  lengthOfService?: string;
  retireForDisablity?: boolean;
  isOfficerRetirementAllowance?: boolean;
  retirementIncomeDeductionAmount: string;
  retirementEarnings: string;
  otherIncome: string;
  otherExpense: string;
  otherExpenseSpecialDeduction: string;
  otherEarings: string;
  totalEarnings: string;
  hasSideJob?: boolean;
  mainJobIncome: string;
  sideJobIncome: string;
  hasBusinessIncome?: boolean;
  hasMiscellaneousIncome?: boolean;
  hasDividendIncome?: boolean;
  hasRealEstateIncome?: boolean;
  hasRetirementIncome?: boolean;
  hasOtherIncome?: boolean;
};

export type FormerJob = {
  id: string;
  paymentAmount?: string;
};

export type Profile = {
  id: string;
  birthday: string;
  income: Income;
  formerJobs: FormerJob[];
};

const INCOME_FRAGMENT = gql`
  fragment Income on Income {
    id
    salaryIncome
    businessIncome
    businessExpense
    miscellaneousIncomeOfficalPension
    miscellaneousIncomeOther
    miscellaneousExpense
    dividendIncome
    dividendExpense
    realEstateIncome
    realEstateExpense
    retirementIncome
    lengthOfService
    retireForDisablity
    isOfficerRetirementAllowance
    otherIncome
    otherExpense
    otherExpenseSpecialDeduction
    otherEarings
    mainJobIncome
    sideJobIncome
    hasSideJob
  }
`;

export const INCOME = gql`
  query income {
    request {
      id
      employee {
        id
      }
      profile {
        id
        birthday
        income {
          ...Income
          hasBusinessIncome
          hasMiscellaneousIncome
          hasDividendIncome
          hasRealEstateIncome
          hasRetirementIncome
          hasOtherIncome
        }
        formerJobs {
          id
          paymentAmount
        }
      }
    }
  }
  ${INCOME_FRAGMENT}
`;
